<template>
  <div class="animated fadeIn">
    <component-header
      title="Edit Survey"
      :hasback="true"
      :hasCreate="false"
      :hasSearch="false"
      :hasReload="false"
      @back-press="$router.push('/survey')"
    />

    <ValidationObserver ref="observer">
      <b-card>
        <b-form @submit.prevent="handleSubmit">
          <b-form-group>
            <div v-for="(question, index) in survey.questions" :key="index">
              <b-row>
                <b-col md="5">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="'Question ' + (index + 1)"
                  >
                    <c-input
                      inputType="text"
                      :inputId="'question-' + index"
                      :lableText="'Question ' + (index + 1) + ' *'"
                      v-model="question.text"
                    />
                    <span class="validate-error cstm-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="5">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="'Answer Type ' + (index + 1)"
                  >
                    <eb-select
                      :id="'answer-type-' + index"
                      v-model="question.type"
                      :selected="question.type"
                      :options="answerTypeOptions"
                      label="label"
                      placeholder="Select Answer Type *"
                      @change="handleAnswerTypeChange(index)"
                    ></eb-select>

                    <span class="validate-error cstm-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="2">
                  <b-button
                   variant="danger"
                   class="w-50 mb-1"
                   style="min-width: 80px"
                    @click="
                      question.id
                        ? removeQuestion(question.id)
                        : survey.questions.splice(index, 1)
                    "
                  >
                    Remove
                  </b-button>
                  <b-button
                    variant="primary"
                    class="ml-0 mt-1 w-50"
                    style="min-width: 80px"
                    @click="question.id ? updateQuestionData(index) : addQuestion(index)"
                    >{{ question.id ? "Update" : "Add" }}</b-button
                  >
                </b-col>
              </b-row>
              <div v-if="['radio', 'select'].includes(question.type)">
                <b-form-group :label="'Options for ' + question.text">
                  <div v-for="(option, optIndex) in question.options" :key="optIndex">
                    <b-row>
                      <b-col>
                        <b-form-input
                          :id="'option-' + index + '-' + optIndex"
                          v-model="option.text"
                          placeholder="Enter Option"
                          required
                        ></b-form-input>
                      </b-col>
                      <b-col cols="auto">
                        <b-button
                          size="sm"
                          class="button-circle"
                          @click="removeOption(index, optIndex)"
                          variant="danger"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button variant="primary" @click="addOption(index)" class="mt-2"
                    >Add Option</b-button
                  >
                </b-form-group>
              </div>
              <div v-if="question.type === 'rating'">
                <b-row>
                  <b-col>
                    <b-form-group label="Min Rating">
                      <b-form-input
                        type="number"
                        v-model.number="question.minRating"
                        min="1"
                        max="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Max Rating">
                      <b-form-input
                        type="number"
                        v-model.number="question.maxRating"
                        min="1"
                        max="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <hr />
            </div>
            <b-button variant="primary" @click="addNewQuestion">Add Question</b-button>
          </b-form-group>

          <b-row class="justify-content-center mt-4">
            <b-col cols="auto">
              <b-button variant="danger" @click="cancelSurvey">Cancel</b-button>
            </b-col>
            <b-col cols="auto">
              <b-button type="submit" variant="success">Update</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import ebSelect from "@/components/FormElements/Select";
import componentHeader from "@/components/componentNewHeader";
import survey from "@/router/survey";

export default {
  name: "ViewSurvey",
  components: {
    cInput,
    ebSelect,
    ValidationObserver,
    ValidationProvider,
    componentHeader,
  },
  data() {
    return {
      survey: {
        _id: "",
        createdBy: "",
        status: "",
        createdAt: "",
        questions: [
          {
            text: "",
            type: "",
            options: [],
            maxRating: 0,
            minRating: 0,
          },
        ],
      },
      answerTypeOptions: ["text", "textarea", "radio", "select", "rating"],
    };
  },
  methods: {
    addNewQuestion() {
      this.survey.questions.push({
        text: "",
        type: "",
        options: [],
        maxRating: 0,
        minRating: 0,
      });
    },
    async removeQuestion(id) {
      await this.$swal({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store.dispatch("survey/deleteQuestion", id).then(() => {
            this.$toasted.success("Survey Deleted Successfully");
            this.getQuestionList();
          });
          this.isLoading = false;
        }
      });
    },
    addOption(questionIndex) {
      this.survey.questions[questionIndex].options.push({ text: "" });
    },
    removeOption(questionIndex, optionIndex) {
      this.survey.questions[questionIndex].options.splice(optionIndex, 1);
    },
    addMatrixRow(questionIndex) {
      this.survey.questions[questionIndex].rows.push({ text: "" });
    },
    removeMatrixRow(questionIndex, rowIndex) {
      this.survey.questions[questionIndex].rows.splice(rowIndex, 1);
    },
    addMatrixColumn(questionIndex) {
      this.survey.questions[questionIndex].columns.push({ text: "" });
    },
    removeMatrixColumn(questionIndex, colIndex) {
      this.survey.questions[questionIndex].columns.splice(colIndex, 1);
    },
    handleAnswerTypeChange(index) {
      const question = this.survey.questions[index];
      if (["radio", "select"].includes(question.type)) {
        question.options = [];
      } else {
        question.options = [];
      }
    },
    handleSubmit() {
      this.$router.push("/survey");
    },
    cancelSurvey() {
      this.$router.push("/survey");
    },
    addQuestion(index) {
      const newQuestion = this.survey.questions[index];
      const payloadData = {
        questionSet: this.$route.params.surveyId,
        type: ["radio", "select"].includes(newQuestion.type)
          ? "MCQ"
          : ["text", "textarea"].includes(newQuestion.type)
          ? "DESCRIPTIVE"
          : "RANGE",
        text: newQuestion.text,
        points: 1,
      };
      if (["radio", "select"].includes(newQuestion.type)) {
        payloadData.options = newQuestion.options.map((option) => ({
          text: option.text,
        }));
      } else if (newQuestion.type === "rating") {
        payloadData.range = [newQuestion.minRating, newQuestion.maxRating];
      }
      this.$store.dispatch("survey/createQuestion", payloadData);
      this.$toasted.show("Question added successfully.", {
        type: "success",
        duration: 5000,
      });
    },
    updateQuestionData(index) {
      const question = this.survey.questions[index];
      const payloadData = {
        id: question.id,
        data: {
          questionSet: this.$route.params.surveyId,
          type: ["radio", "select"].includes(question.type)
            ? "MCQ"
            : ["text", "textarea"].includes(question.type)
            ? "DESCRIPTIVE"
            : "RANGE",
          text: question.text,
          points: 1,
        },
      };
      if (["radio", "select"].includes(question.type)) {
        payloadData.data.options = question.options.map((option) => ({
          text: option.text,
        }));
      } else if (question.type === "rating") {
        payloadData.data.range = [question.minRating, question.maxRating];
      }
      this.$store.dispatch("survey/updateQuestion", payloadData);
      this.$toasted.show("Question updated successfully.", {
        type: "success",
        duration: 5000,
      });
    },
    getQuestionList() {
      this.$store
        .dispatch("survey/getQuestions", this.$route?.params?.surveyId)
        .then((res) => {
          this.survey.questions = res.data.map((question) => {
            let type = "";
            if (question.type === "MCQ") {
              type = "radio";
            } else if (question.type === "DESCRIPTIVE") {
              type = "text";
            } else if (question.type === "RANGE") {
              type = "rating";
            }
            return {
              id: question.id,
              text: question.text,
              type: type,
              options: question.options || [],
              maxRating: question.range ? question.range[1] : 0,
              minRating: question.range ? question.range[0] : 0,
            };
          });
        });
    },
  },
  mounted() {
    this.getQuestionList();
  },
};
</script>

<style scoped>
.card-wrap {
  margin: 20px;
}
.validate-error {
  color: red;
}
</style>
